
import { TestResponse } from "@/types/test-response";
import { TestIntegrityScore } from "../../responses/TestIntegrityScore";
import { TestActivityTimeline } from "../../responses/TestActivityTimeline";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity } from "lucide-react";
import { MonitoringMetricCards } from "../../responses/MonitoringMetricCards";
import { HorizontalTestTimeline } from "../../responses/HorizontalTestTimeline";
import { WebcamGallery } from "../../responses/WebcamGallery";


interface MonitoringTabProps {
  testResponse: TestResponse;
}

export function MonitoringTab({ testResponse }: MonitoringTabProps) {
  const events = testResponse.events || [];
  // Extract additional data that might be useful for future enhancements
  const questions = testResponse.test?.questions || [];
  const startTime = testResponse.started_at;
  const endTime = testResponse.completed_at;
  
  return (
    <div className="space-y-8 w-full">
      {/* 1. Monitoring Metric Cards */}
      <div className="w-full">
        <MonitoringMetricCards testResponse={testResponse} />
      </div>
      
      {/* 2. Webcam Gallery */}
      <WebcamGallery testResponseId={testResponse.id} />
      
      
      {/* 4. Horizontal Timeline */}
      <HorizontalTestTimeline testResponse={testResponse} />
      
      {/* 4. Detailed Event List */}
      <Card className="shadow-sm border overflow-hidden">
        <CardHeader className="pb-3 bg-card/50">
          <CardTitle className="flex items-center gap-2 text-lg font-semibold">
            <Activity className="h-5 w-5" />
            Detailed Event Log
          </CardTitle>
        </CardHeader>
        <CardContent className="p-6">
          <TestActivityTimeline events={events} />
        </CardContent>
      </Card>
    </div>
  );
}
